module.exports = __webpack_public_path__ + "static/media/motor-ceo.3affa31e.jpg";